// import { galaxoStats } from '../../../src/assets/js/src/scripts-galaxo.js';

var type;

function init() {

	var $list = $('.galaxo-list');

	if ($('body').hasClass('tpl-restaurants')) {
		type = 'restaurants';
	} else if ($('body').hasClass('tpl-services')) {
		type = 'services';
	} else if ($('body').hasClass('tpl-stores')) {
		type = 'stores';
	}

	if ($('.galaxo-list__pane').length > 1) {
		initCarousel();
	}

	// $('.galaxo-list a[data-href]').each(function() {
	// 	this.href = this.getAttribute('data-href');
	// });

	$list.on('mousedown', 'a', function(e) {

		var title = this.getAttribute('data-title');

		e.preventDefault();
		document.location.href = this.href;

		/*
		galaxoStats.send('list', title, type).always(() => {
			setTimeout(() => { document.location.href = this.href; }, 150);
		});
		*/

	});

}


function initCarousel() {

	var $list = $('.galaxo-list');
	var $listPanes = $('.galaxo-list__pane');
	var $listScroller = $('.galaxo-list__scroller');
	var currentPane = 0;

	$list.addClass('is-carousel');

	// Prev / next
	$list.on('mousedown', '.galaxo-list__nav', function() {

		var $button = $(this);
		var title = $button.data('title');

		window.setTimeout(function() {

			$list.removeClass('is-first is-last');

			if ($button.is('.nav--prev')) {
				currentPane = Math.max(currentPane - 1, 0);
			} else {
				currentPane = Math.min(currentPane + 1, $listPanes.length - 1);
			}

			$listScroller.css({
				transform: 'translateX(-' + currentPane * (100 / $listPanes.length) + '%)'
			});

			if (currentPane === 0) {
				$list.addClass('is-first');
			} else if (currentPane === $listPanes.length - 1) {
				$list.addClass('is-last');
			}

			// Statistics
			//galaxoStats.send('list_nav', title, type);

		}, 150);

	});
}

export default {
	init
};
